export const isProd = () => process.env.VUE_APP_ENV_TYPE == 3

export const ENDPOINT_URL = process.env.VUE_APP_TRACKER_API_URL

if (!ENDPOINT_URL && !isProd()) {
	console.warn('[tracking] VUE_APP_TRACKER_API_URL is not set, tracking is off')
}

export const FLUSH_INTERVAL_MS = 5000

export const MAX_BUFFER_SIZE = 50

export const MAX_BACKOFF_MS = 5 * 60 * 1000

export const MAX_RETRY_BATCHES = 20

export const REFRESH_COOLDOWN_MS = 5 * 60 * 1000

// Kept in sessionStorage so logout's localStorage.clear() doesn't delete it.
export const RETRY_QUEUE_PREFIX = 'hire3x_tracking_retry_'

export const DASHBOARD_SECTIONS = Object.freeze({
	JOBS_PANEL: "jobs_panel",
	COURSES_PANEL: "courses_panel",
	LANDING_JOBS_PANEL: "landing_jobs_panel",
	LANDING_COURSES_PANEL: "landing_courses_panel",
})

export function isValidSectionKey(key) {
	return Object.values(DASHBOARD_SECTIONS).includes(key)
}
